import { client } from "@common/client/client.gen"
import type { UIRequest } from "@common/lib/ui-state"
import type { AnyRouter } from "@tanstack/react-router"
import type { InternalAxiosRequestConfig } from "axios"

const MAX_REQUESTS = 15

const log = new Map<string, UIRequest>()

const sentFrom = new WeakMap<InternalAxiosRequestConfig, string>()

function toPath(url: string): string {
  try {
    const parsed = new URL(url)
    return parsed.pathname + parsed.search
  } catch {
    return url
  }
}

function record(request: UIRequest) {
  const key = `${request.method} ${request.path.split("?")[0]}`
  log.delete(key)
  log.set(key, request)

  while (log.size > MAX_REQUESTS) {
    const oldest = log.keys().next().value
    if (oldest === undefined) break
    log.delete(oldest)
  }
}

let installed = false

export function installRequestLog(router: AnyRouter) {
  if (installed) return
  installed = true

  client.instance.interceptors.request.use((config) => {
    sentFrom.set(config, router.state.location.pathname)
    return config
  })

  client.instance.interceptors.response.use((response) => {
    const page = sentFrom.get(response.config) ?? router.state.location.pathname
    const method = (response.config.method ?? "get").toUpperCase()
    const path = toPath(response.config.url ?? "")
    if (path) record({ method, path, page })
    return response
  })
}

export function recentRequests(): UIRequest[] {
  return [...log.values()].reverse()
}
